import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ViewportService {

  screenWidth$: BehaviorSubject<number> = new BehaviorSubject(undefined);

  setScreenwidth(w): void {
      this.screenWidth$.next(w);
  }

  getScreenWidth(): number {
      return this.screenWidth$.getValue();
  }
}
